import React, {Component} from 'react'
import {connect} from "react-redux";
import {createStructuredSelector} from "reselect"
import checkIcon from "manager/../images/check-clipboard.svg"
import greenCheckIcon from "manager/../images/circle-check.svg"
import emptyCircleIcon from "manager/../images/circle-empty.svg"
import canceledIcon from "manager/../images/icon-canceled.svg"
import rejectedIcon from "manager/../images/icon-rejected.svg"
import externalLinkIcon from "manager/../images/icon-external-link.svg"
import styled from "styled-components"
import {
  DESKTOP_BREAKPOINT,
  ORDER_ACCEPTED,
  ORDER_CANCELED_REJECTED, ORDER_STATUS, ORDER_STATUS_LABEL
} from "manager/views/components/Settlement/constants"
import {
  selectAgentOpId,
  selectLatestQualiaOrder,
  selectSelectedSettlementProvider, selectTransactionOpId
} from "manager/selectors/referral_selectors"
import {SettlementCard} from "manager/views/components/Settlement/Common/SettlementCard"
import moment from "moment-timezone";
import {segmentEventTracker} from "common/analytics"
import {
  SettlementButton,
  TextButtonContainer,
  TextContainer
} from "manager/views/components/Settlement/Common/TextButton"

const OrderStatusContainer = styled(SettlementCard)`
  display: flex;
`
const Icon = styled.div`
  background-image: url(${props => props.icon});
  margin-right: 10px;
  margin-bottom: 40px;
  width: ${props => (props.pending || props.accepted) ? '22px' : '20px'};
  height: ${props => props.status === ORDER_STATUS.CANCELED ? '21px' : props.status === ORDER_STATUS.REJECTED ? '20px' : '22px'};
`
const ExternalLinkIcon = styled.div`
  background-image: url(${externalLinkIcon});
  margin-right: 10px;
  height: 14px;
  flex: 0 0 14px;
`
const CheckIcon = styled(Icon)`
  background-image: url(${checkIcon});
  margin-top: 30px;
  height: 21px;
  flex: 0 0 16px;
`
const GreenCheckIcon = styled(Icon)`
  background-image: url(${greenCheckIcon});
  height: 22px;
  width: 22px;
`

const StatusContainer = styled.div`
  display: flex;
  align-items: end;
`
const StatusContainerRow = styled.div`
  display: flex;
  flex-direction: column;
`
const HeaderDiv = styled.div`
  color: #545454;
  font-size: 20px;
  font-weight: bold;
`
const TextDiv = styled.div`
  color: #8C8C8C;
  font-size: 14px;
  margin: 2px 0px 20px;
  @media screen and ${DESKTOP_BREAKPOINT} {
    width: 368px;
    font-size: 16px;
  }
`

const OrderStatusView = props => {
  let status = props.status
  let icon

  switch(status) {
    case ORDER_STATUS.CANCELED:
      icon = canceledIcon
      break
    case ORDER_STATUS.REJECTED:
      icon = rejectedIcon
      break
    case ORDER_STATUS.PENDING:
      icon = emptyCircleIcon
      break
    default:
      icon = greenCheckIcon
  }

  return (
    <StatusContainer>
      <Icon icon={icon} pending={props.pending} accepted={props.accepted} status={status}/>
      <StatusContainerRow>
        <HeaderDiv style={{fontSize: '16px'}}>
          {props.pending ? ORDER_STATUS_LABEL[ORDER_STATUS.PENDING]: ORDER_STATUS_LABEL[status]}
        </HeaderDiv>
        <TextDiv>{props.pending ? "" : moment.utc(props.updated_at).local().format("MM/DD/YY [at] h:mm A") }</TextDiv>
      </StatusContainerRow>
    </StatusContainer>
  )
}

class OrderStatus extends Component {
  componentDidMount() {
    segmentEventTracker("Order-Status Viewed",{'transaction_op_id': this.props.transaction_op_id, 'agent_op_id': this.props.agent_op_id})
  }

  render() {
    const {qualia_order, settlement_provider} = this.props

    let qualia_status = qualia_order ? qualia_order.status : null
    let qualia_created_at = qualia_order ? qualia_order.created_at : null
    let qualia_updated_at = qualia_order ? qualia_order.updated_at : null
    let isCanceledRejected = ORDER_CANCELED_REJECTED.indexOf(qualia_status) > -1
    let isAccepted = ORDER_ACCEPTED.indexOf(qualia_status) > -1
    let isPending = (qualia_status === ORDER_STATUS.PENDING)

    return (
      <OrderStatusContainer canceled={isCanceledRejected} paddingLeft='35px' paddingRight='60px'>
        <CheckIcon/>
        <TextButtonContainer>
          <TextContainer>
            <HeaderDiv style={{marginBottom: '20px'}}>Order Status</HeaderDiv>
            {isPending &&
            <TextDiv>
              Check back here to see the status of your order. Once accepted, you can log in to track progress towards closing.
            </TextDiv>}
            <StatusContainer>
              <GreenCheckIcon/>
              <StatusContainerRow>
                <HeaderDiv style={{fontSize: '16px'}}>{ORDER_STATUS_LABEL.ORDER_PLACED}</HeaderDiv>
                <TextDiv>{moment.utc(qualia_created_at).local().format("MM/DD/YY [at] h:mm A")}</TextDiv>
              </StatusContainerRow>
            </StatusContainer>
            <OrderStatusView status={qualia_status} pending={isPending} accepted={isAccepted} updated_at={qualia_updated_at}/>
            {isCanceledRejected &&
            <TextDiv>
              Contact {qualia_order.settlement_agency_external_name} if you already have an open order or if you have further questions.
            </TextDiv>}
          </TextContainer>
          {!isCanceledRejected &&
          <SettlementButton disabled={!isAccepted} primary oldColorPalette={true}
                            largerFont={true} paddingTopBottom={10} paddingLeftRight={22.5}
                            onClick={() => window.open(settlement_provider.progress_tracker_url, '_blank')}>
            <ExternalLinkIcon/>
            <span style={{marginRight: '12px'}}>View progress tracker</span>
          </SettlementButton>}
        </TextButtonContainer>
      </OrderStatusContainer>
    )
  }
}

const selector = createStructuredSelector({
  qualia_order: selectLatestQualiaOrder,
  settlement_provider: selectSelectedSettlementProvider,
  transaction_op_id: selectTransactionOpId,
  agent_op_id: selectAgentOpId,
})

export default connect(selector)(OrderStatus)
